import { forms } from './data';

export const newsletter = [forms.newsletter.email] as const;

export type ReviewerHomeFormDataKeys = (typeof newsletter)[number];

export type ReviewerHomeForm = Record<ReviewerHomeFormDataKeys, string>;
